import { render, staticRenderFns } from "./InfoTranslate.vue?vue&type=template&id=7867c97b&scoped=true"
import script from "./InfoTranslate.vue?vue&type=script&lang=js"
export * from "./InfoTranslate.vue?vue&type=script&lang=js"
import style0 from "./InfoTranslate.vue?vue&type=style&index=0&id=7867c97b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7867c97b",
  null
  
)

export default component.exports